export const IMPORTS_INDEX_TOUR = {
  id: "imports_index",
  steps: [
    {
      element: '[data-tour="imports-form"]',
      popover: {
        title: "Importar clientes",
        description:
          "Traga clientes e assinaturas ativas do Asaas ou Stripe. Você revisa tudo antes de confirmar.",
        side: "bottom",
      },
    },
  ],
};
